import posthog from 'posthog-js';
import { AuthenticationUser } from '../api/authentication/authenticationTypes';

export interface PosthogServiceInterface {
  init: () => void;
  identify: (user: AuthenticationUser) => void;
  captureOnboardingCompletedEvent: (user: AuthenticationUser) => void;
  getClient: () => typeof posthog;
}

export class PosthogService implements PosthogServiceInterface {
  private isInitialized = false;

  constructor() {
    this.init = this.init.bind(this);
    this.identify = this.identify.bind(this);
    this.captureOnboardingCompletedEvent = this.captureOnboardingCompletedEvent.bind(this);
    this.getClient = this.getClient.bind(this);
  }

  init() {
    if (!this.isInitialized) {
      posthog.init((process.env.REACT_APP_POSTHOG_KEY || ''), {
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        defaults: '2025-05-24',
        capture_exceptions: true,
        debug: process.env.NODE_ENV === "development",
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '*',
        },
      });
      this.isInitialized = true;
    }
  }

  identify(user: AuthenticationUser) {
    if (!this.isInitialized) {
      this.init();
    }
    posthog.identify(user.id, {
      email: user.email,
    });
  }

  captureOnboardingCompletedEvent(user: AuthenticationUser) {
    if (!this.isInitialized) {
      this.init();
    }
    posthog.capture('onboarding_completed', {
      email: user.email,
    });
  }

  getClient() {
    if (!this.isInitialized) {
      this.init();
    }
    return posthog;
  }
}

export default PosthogService;